import { METHODS, num, fmtFull } from "../lib/format";

const Row = ({ l, r, bold }) => (
  <div className={`flex justify-between gap-2 ${bold ? "font-bold" : ""}`}><span>{l}</span><span className="text-right whitespace-nowrap">{r}</span></div>
);
const Sep = () => <div className="border-t border-dashed border-black/60 my-1.5" />;
const dt = (s) => (s ? fmtFull(s) : "-");

export const ShiftReport = ({ shift: s, store, width = "58mm", print = false }) => {
  const w = print ? (width === "80mm" ? "72mm" : "48mm") : width === "80mm" ? "300px" : "220px";
  return (
    <div className="receipt-paper text-[11px] leading-snug" style={{ width: w, padding: print ? "2mm" : "14px 12px" }} data-testid="shift-report-preview">
      <div className="text-center font-bold">
        <div className="uppercase">{store?.store_name}</div>
        <div>LAPORAN TUTUP KASIR</div>
      </div>
      <Sep />
      <div>Kasir : {s.cashier_name}</div>
      <div>Buka  : {dt(s.opened_at)}</div>
      <div>Tutup : {dt(s.closed_at)}</div>
      <Sep />
      <Row l="Jumlah transaksi" r={s.tx_count} />
      <Row l="Item terjual" r={s.items_sold} />
      {s.void_count > 0 && <Row l="Dibatalkan" r={s.void_count} />}
      <Row l="Total diskon" r={num(s.discount_total)} />
      <Sep />
      {(s.by_method || []).map((m) => <Row key={m.method} l={METHODS[m.method] || m.method} r={num(m.total)} />)}
      <Row l="TOTAL PENJUALAN" r={num(s.total_sales)} bold />
      <Sep />
      <Row l="Kas awal" r={num(s.opening_cash)} />
      <Row l="Penjualan tunai" r={num(s.cash_sales)} />
      <Row l="Kas seharusnya" r={num(s.expected_cash)} />
      {s.closing_cash != null && (
        <>
          <Row l="Kas dihitung" r={num(s.closing_cash)} />
          <Row l="Selisih" r={(s.difference > 0 ? "+" : "") + num(s.difference)} bold />
        </>
      )}
      {s.closing_note && (<><Sep /><div>Catatan: {s.closing_note}</div></>)}
      <Sep />
      <div className="flex justify-between pt-6"><span>Ttd Kasir</span><span>Ttd Supervisor</span></div>
    </div>
  );
};
